module.exports = __webpack_public_path__ + "img/sm-instagram.160ba74f.svg";